// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"155":"e1a9a6de","284":"1ad04771"}[chunkId] + ".chunk.css";
};